// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.machine-live-monitor {
  padding: 20px;
  background: var(--m-background-color, #f4f6f9);
  min-height: 100vh;
}
.machine-live-monitor .mlm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}
.machine-live-monitor .mlm-header .mlm-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.machine-live-monitor .mlm-header .mlm-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--m-text, #1a2236);
  margin: 0;
}
.machine-live-monitor .mlm-header .mlm-ws-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
}
.machine-live-monitor .mlm-header .mlm-ws-status.online {
  background: #e6f9f6;
  color: #00a896;
}
.machine-live-monitor .mlm-header .mlm-ws-status.offline {
  background: #fdecea;
  color: #d32f2f;
}
.machine-live-monitor .mlm-header .mlm-ws-status::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.machine-live-monitor .mlm-header .mlm-ws-status.online::before {
  background: #00c9b7;
}
.machine-live-monitor .mlm-header .mlm-ws-status.history {
  background: var(--m-subtle-card-background-color, #f4f6fa);
  color: var(--m-text-muted, #6a768b);
}
.machine-live-monitor .mlm-header .mlm-ws-status.history::before {
  background: #94a3b8;
}
.machine-live-monitor .mlm-header .mlm-header-right {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.machine-live-monitor .mlm-header .mlm-selector-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.machine-live-monitor .mlm-header .mlm-selector-wrap label {
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.machine-live-monitor .mlm-header .mlm-select {
  padding: 8px 14px;
  border: 1px solid var(--m-border, #dde2ee);
  border-radius: 8px;
  background: var(--m-card-background-color, #fff);
  font-size: 13px;
  color: var(--m-text, #1a2236);
  outline: none;
  min-width: 180px;
  cursor: pointer;
}
.machine-live-monitor .mlm-header .mlm-select:focus {
  border-color: #00c9b7;
  box-shadow: 0 0 0 3px rgba(0, 201, 183, 0.15);
}
.machine-live-monitor .mlm-header .mlm-refresh-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #00c9b7;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  height: 36px;
}
.machine-live-monitor .mlm-header .mlm-refresh-btn:hover {
  background: #00a896;
}
.machine-live-monitor .mlm-header .mlm-refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.machine-live-monitor .mlm-header .mlm-refresh-btn .spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.machine-live-monitor .mlm-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto auto auto;
  gap: 16px;
}
.machine-live-monitor .mlm-grid .mlm-machine-info {
  grid-column: 1;
  grid-row: 1;
}
.machine-live-monitor .mlm-grid .mlm-shift-info {
  grid-column: 2;
  grid-row: 1;
}
.machine-live-monitor .mlm-grid .mlm-production-count {
  grid-column: 3;
  grid-row: 1;
}
.machine-live-monitor .mlm-grid .mlm-last-hour {
  grid-column: 4;
  grid-row: 1;
}
.machine-live-monitor .mlm-grid .mlm-machine-status {
  grid-column: 1;
  grid-row: 2;
  min-height: 0;
}
.machine-live-monitor .mlm-grid .mlm-time-stats {
  grid-column: 2;
  grid-row: 2;
  min-height: 0;
}
.machine-live-monitor .mlm-grid .mlm-top-stops {
  grid-column: 3/5;
  grid-row: 2;
  min-height: 0;
}
.machine-live-monitor .mlm-grid .mlm-oee {
  grid-column: 1/3;
  grid-row: 3;
}
.machine-live-monitor .mlm-grid .mlm-speed-nostop {
  grid-column: 3;
  grid-row: 3;
}
.machine-live-monitor .mlm-grid .mlm-speed-total {
  grid-column: 4;
  grid-row: 3;
}
.machine-live-monitor .mlm-card {
  background: var(--m-card-background-color, #fff);
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  border: 1px solid var(--m-border, #eaecf0);
}
.machine-live-monitor .mlm-card-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--m-text-light, #7a8499);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 14px;
}
.machine-live-monitor .mlm-card-title--inline {
  margin-bottom: 0;
}
.machine-live-monitor .mlm-card-title small {
  font-size: 10px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 4px;
}
.machine-live-monitor .mlm-card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}
.machine-live-monitor .mlm-card-title-row .mlm-card-title--inline {
  margin-bottom: 0;
}
.machine-live-monitor .mlm-card-detail-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 5px 8px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text-light, #7a8499);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}
.machine-live-monitor .mlm-card-detail-btn:hover:not(:disabled) {
  color: #00a896;
  border-color: rgba(0, 201, 183, 0.45);
  background: #e6f9f6;
}
.machine-live-monitor .mlm-card-detail-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.machine-live-monitor .mlm-stops-sort-toggle {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 6px;
  overflow: hidden;
  background: var(--m-background-color, #f6f7fb);
  flex-shrink: 0;
}
.machine-live-monitor .mlm-stops-sort-btn {
  border: none;
  background: transparent;
  color: var(--m-text-light, #7a8499);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 7px 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.machine-live-monitor .mlm-stops-sort-btn:hover {
  background: var(--m-surface-subtle, #f8fafc);
  color: var(--m-text, #1a2236);
}
.machine-live-monitor .mlm-stops-sort-btn.active {
  background: var(--m-card-background-color, #fff);
  color: #00a896;
  box-shadow: inset 0 0 0 1px rgba(0, 168, 150, 0.15);
}
.machine-live-monitor .mlm-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.machine-live-monitor .mlm-entry-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  padding: 0;
  background: #e6f9f6;
  border: 1px solid rgba(0, 201, 183, 0.35);
  border-radius: 50%;
  color: #00a896;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.machine-live-monitor .mlm-entry-add-btn:hover {
  background: #00c9b7;
  border-color: #00c9b7;
  color: #fff;
}
.machine-live-monitor .mlm-entry-add-btn--scrap:hover {
  background: #dc2626;
  border-color: #dc2626;
}
.machine-live-monitor .mlm-entry-add-btn--production:hover {
  background: #00b4f3;
  border-color: #00b4f3;
}
.machine-live-monitor .mlm-entry-add-btn--stop:hover {
  background: #ea580c;
  border-color: #ea580c;
}
.machine-live-monitor .mlm-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid var(--m-border, #f0f2f5);
}
.machine-live-monitor .mlm-info-row:last-child {
  border-bottom: none;
}
.machine-live-monitor .mlm-info-label {
  font-size: 12px;
  color: var(--m-text-light, #7a8499);
  font-weight: 500;
}
.machine-live-monitor .mlm-info-value {
  font-size: 13px;
  color: var(--m-text, #1a2236);
  font-weight: 600;
  text-align: right;
  max-width: 65%;
  word-break: break-all;
}
.machine-live-monitor .mlm-info-value--part {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  word-break: normal;
}
.machine-live-monitor .mlm-part-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.machine-live-monitor .mlm-part-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 2px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--m-text-light, #7a8499);
  cursor: pointer;
  opacity: 0.85;
  transition: color 0.15s, opacity 0.15s;
}
.machine-live-monitor .mlm-part-edit-btn:hover {
  color: #00a896;
  opacity: 1;
}
.machine-live-monitor .mlm-cycle-edit-part {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #1a2236);
  margin-bottom: 14px;
}
.machine-live-monitor .mlm-cycle-edit-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.machine-live-monitor .mlm-cycle-edit-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.machine-live-monitor .mlm-cycle-edit-error {
  margin-top: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #c62828;
}
.machine-live-monitor .mlm-status-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
}
.machine-live-monitor .mlm-status-badge.online {
  background: #e6f9f6;
  color: #00a896;
}
.machine-live-monitor .mlm-status-badge.offline {
  background: #fdecea;
  color: #c62828;
}
.machine-live-monitor .mlm-status-badge.is-clickable {
  border: none;
  cursor: pointer;
  font-family: inherit;
}
.machine-live-monitor .mlm-status-badge.is-clickable:hover {
  filter: brightness(0.96);
}
.machine-live-monitor .mlm-shift-name {
  font-size: 32px;
  font-weight: 800;
  color: var(--m-text, #1a2236);
  line-height: 1;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.machine-live-monitor .mlm-shift-sub {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
  text-transform: none;
  letter-spacing: 0;
}
.machine-live-monitor .mlm-workstate-badge {
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  line-height: 1;
  border: 1px solid var(--m-border, #eaecf0);
}
.machine-live-monitor .mlm-workstate-badge.break {
  background: #fff7ed;
  color: #c2410c;
  border-color: #fed7aa;
}
.machine-live-monitor .mlm-workstate-badge.tolerance, .machine-live-monitor .mlm-workstate-badge.tolerance_late {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}
.machine-live-monitor .mlm-workstate-badge.tolerance_start {
  background: #f0fdf4;
  color: #15803d;
  border-color: #bbf7d0;
}
.machine-live-monitor .mlm-workstate-badge.tolerance_early {
  background: #fffbeb;
  color: #b45309;
  border-color: #fde68a;
}
.machine-live-monitor .mlm-workstate-badge.overtime {
  background: #faf5ff;
  color: #7e22ce;
  border-color: #e9d5ff;
}
.machine-live-monitor .mlm-workstate-badge.outside, .machine-live-monitor .mlm-workstate-badge.no_shift {
  background: var(--m-surface-subtle, #f1f5f9);
  color: var(--m-text-light, #475569);
  border-color: var(--m-border, #e2e8f0);
}
.machine-live-monitor .mlm-shift-time-label {
  font-size: 11px;
  color: var(--m-text-light, #7a8499);
  margin-bottom: 6px;
}
.machine-live-monitor .mlm-shift-time-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}
.machine-live-monitor .mlm-shift-time {
  font-size: 18px;
  font-weight: 700;
  color: var(--m-text, #1a2236);
  letter-spacing: 1px;
}
.machine-live-monitor .mlm-breaks-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 4px 7px;
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}
.machine-live-monitor .mlm-breaks-btn:hover {
  background: #ffedd5;
  border-color: #fdba74;
}
.machine-live-monitor .mlm-breaks-count {
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
.machine-live-monitor .mlm-no-shift {
  font-size: 13px;
  color: var(--m-text-light, #aab0bc);
  text-align: center;
  margin-top: 20px;
}
.machine-live-monitor .mlm-production-count {
  overflow: hidden;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.machine-live-monitor .mlm-production-section-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
}
.machine-live-monitor .mlm-production-produced {
  margin-bottom: 2px;
}
.machine-live-monitor .mlm-production-produced-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.machine-live-monitor .mlm-production-produced-header .mlm-production-section-label {
  margin-bottom: 0;
}
.machine-live-monitor .mlm-production-parts {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: 100%;
  padding: 0px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
.machine-live-monitor .mlm-production-parts:hover {
  scrollbar-color: var(--m-border, #d0d5dd) transparent;
}
.machine-live-monitor .mlm-production-parts::-webkit-scrollbar {
  height: 3px;
}
.machine-live-monitor .mlm-production-parts::-webkit-scrollbar-track {
  background: transparent;
}
.machine-live-monitor .mlm-production-parts::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 3px;
}
.machine-live-monitor .mlm-production-parts:hover::-webkit-scrollbar-thumb {
  background: var(--m-border, #d0d5dd);
}
.machine-live-monitor .mlm-production-part-item {
  flex: 0 0 auto;
  min-width: 72px;
  max-width: 96px;
  padding: 0 16px;
  scroll-snap-align: start;
  text-align: center;
}
.machine-live-monitor .mlm-production-part-item:first-child {
  padding-left: 0;
}
.machine-live-monitor .mlm-production-part-item:not(:last-child) {
  border-right: 1px solid var(--m-border, #dde2ee);
}
.machine-live-monitor .mlm-production-part-item.is-active .mlm-production-part-qty {
  color: #00a896;
}
.machine-live-monitor .mlm-production-part-item.is-active .mlm-production-part-name {
  color: #008f80;
  font-weight: 600;
}
.machine-live-monitor .mlm-production-part-qty {
  font-size: 32px;
  font-weight: 800;
  color: var(--m-text, #1a2236);
  line-height: 1;
  margin-bottom: 6px;
}
.machine-live-monitor .mlm-production-part-name {
  font-size: 10px;
  font-weight: 500;
  color: var(--m-text-light, #7a8499);
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.machine-live-monitor .mlm-production-scrap {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}
.machine-live-monitor .mlm-production-scrap-main {
  min-width: 0;
}
.machine-live-monitor .mlm-production-scrap-main .mlm-production-section-label {
  margin-bottom: 4px;
}
.machine-live-monitor .mlm-production-scrap-main .mlm-scrap-number {
  font-size: 28px;
  margin-bottom: 0;
}
.machine-live-monitor .mlm-big-number {
  font-size: 40px;
  font-weight: 800;
  color: var(--m-text, #1a2236);
  line-height: 1;
  margin-bottom: 4px;
}
.machine-live-monitor .mlm-big-number.secondary {
  color: var(--m-text-light, #7a8499);
  font-size: 28px;
}
.machine-live-monitor .mlm-big-number.mlm-scrap-number {
  color: #dc2626;
}
.machine-live-monitor .mlm-big-number-label {
  font-size: 11px;
  color: var(--m-text-light, #7a8499);
  margin-bottom: 8px;
}
.machine-live-monitor .mlm-divider {
  height: 1px;
  background: var(--m-border, #eaecf0);
  margin: 10px 0;
}
.machine-live-monitor .mlm-machine-status {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.machine-live-monitor .mlm-donut-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
}
.machine-live-monitor .donut-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.machine-live-monitor .donut-label {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: var(--m-text, #1a2236);
  text-align: center;
  pointer-events: none;
  letter-spacing: 1px;
}
.machine-live-monitor .mlm-donut-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--m-text-light, #7a8499);
  font-weight: 600;
  margin-top: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.machine-live-monitor .mlm-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.machine-live-monitor .mlm-time-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}
.machine-live-monitor .mlm-time-row:last-child {
  margin-bottom: 0;
}
.machine-live-monitor .mlm-time-value {
  font-size: 24px;
  font-weight: 800;
  color: var(--m-text, #1a2236);
  letter-spacing: 1px;
  line-height: 1.2;
}
.machine-live-monitor .mlm-time-label {
  font-size: 11px;
  color: var(--m-text-light, #7a8499);
  margin-top: 2px;
}
.machine-live-monitor .mlm-top-stops {
  overflow: hidden;
}
.machine-live-monitor .mlm-top-stops .mlm-card-title-row {
  flex-shrink: 0;
}
.machine-live-monitor .mlm-empty-stops {
  font-size: 13px;
  color: var(--m-text-light, #aab0bc);
  text-align: center;
  margin-top: 24px;
}
.machine-live-monitor .mlm-stops-table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 199px;
  margin: 0 -20px -4px;
  width: calc(100% + 40px);
}
.machine-live-monitor .mlm-stops-table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
  font-size: 12px;
}
.machine-live-monitor .mlm-stops-table th {
  text-align: left;
  padding: 8px 10px;
  height: 34px;
  box-sizing: border-box;
  background: var(--m-surface-subtle, #f8fafc);
  color: var(--m-text-light, #7a8499);
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--m-border, #eaecf0);
  overflow: hidden;
  text-overflow: ellipsis;
}
.machine-live-monitor .mlm-stops-table td {
  padding: 8px 10px;
  height: 33px;
  box-sizing: border-box;
  color: var(--m-text, #1a2236);
  border-bottom: 1px solid var(--m-border, #f4f6f9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.machine-live-monitor .mlm-stops-table th:nth-child(1),
.machine-live-monitor .mlm-stops-table td:nth-child(1) {
  width: 14%;
  padding-left: 20px;
}
.machine-live-monitor .mlm-stops-table th:nth-child(4),
.machine-live-monitor .mlm-stops-table td:nth-child(4),
.machine-live-monitor .mlm-stops-table th:nth-child(5),
.machine-live-monitor .mlm-stops-table td:nth-child(5),
.machine-live-monitor .mlm-stops-table .mlm-stops-action-col {
  width: 1%;
  white-space: nowrap;
}
.machine-live-monitor .mlm-stops-table th:nth-child(5),
.machine-live-monitor .mlm-stops-table td:nth-child(5) {
  text-align: right;
  padding-right: 4px;
  padding-left: 4px;
}
.machine-live-monitor .mlm-stops-table tr:last-child td {
  border-bottom: none;
}
.machine-live-monitor .mlm-stops-table tr:hover td {
  background: var(--m-surface-subtle, #f8fafc);
}
.machine-live-monitor .mlm-stops-table .mlm-stops-action-col {
  text-align: center;
  padding: 8px 16px 8px 2px;
  overflow: visible;
}
.machine-live-monitor .mlm-stops-table .mlm-stops-action-col .mlm-entry-add-btn {
  width: 24px;
  height: 24px;
}
.machine-live-monitor .mlm-ongoing {
  color: #f59e0b;
  font-weight: 600;
}
.machine-live-monitor .mlm-oee {
  display: flex;
  flex-direction: column;
}
.machine-live-monitor .mlm-gauges-row {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1 1;
  gap: 12px;
  flex-wrap: wrap;
}
.machine-live-monitor .gauge-circle-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.machine-live-monitor .gauge-circle-svg-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.machine-live-monitor .gauge-circle-value {
  position: absolute;
  font-size: 16px;
  font-weight: 800;
  color: var(--m-text, #1a2236);
  text-align: center;
  line-height: 1;
}
.machine-live-monitor .gauge-unit {
  font-size: 10px;
  font-weight: 500;
  display: block;
  text-align: center;
  margin-top: 1px;
}
.machine-live-monitor .gauge-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
  text-align: center;
  white-space: nowrap;
}
.machine-live-monitor .mlm-speed-nostop,
.machine-live-monitor .mlm-speed-total {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 1200px) {
  .machine-live-monitor .mlm-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .machine-live-monitor .mlm-grid .mlm-machine-info {
    grid-column: 1;
    grid-row: 1;
  }
  .machine-live-monitor .mlm-grid .mlm-shift-info {
    grid-column: 2;
    grid-row: 1;
  }
  .machine-live-monitor .mlm-grid .mlm-production-count {
    grid-column: 1;
    grid-row: 2;
  }
  .machine-live-monitor .mlm-grid .mlm-last-hour {
    grid-column: 2;
    grid-row: 2;
  }
  .machine-live-monitor .mlm-grid .mlm-machine-status {
    grid-column: 1;
    grid-row: 3;
  }
  .machine-live-monitor .mlm-grid .mlm-time-stats {
    grid-column: 2;
    grid-row: 3;
  }
  .machine-live-monitor .mlm-grid .mlm-top-stops {
    grid-column: 1/3;
    grid-row: 4;
  }
  .machine-live-monitor .mlm-grid .mlm-oee {
    grid-column: 1/3;
    grid-row: 5;
  }
  .machine-live-monitor .mlm-grid .mlm-speed-nostop {
    grid-column: 1;
    grid-row: 6;
  }
  .machine-live-monitor .mlm-grid .mlm-speed-total {
    grid-column: 2;
    grid-row: 6;
  }
}
@media (max-width: 640px) {
  .machine-live-monitor {
    padding: 12px;
  }
  .machine-live-monitor .mlm-grid {
    grid-template-columns: 1fr;
  }
  .machine-live-monitor .mlm-grid .mlm-machine-info,
  .machine-live-monitor .mlm-grid .mlm-shift-info,
  .machine-live-monitor .mlm-grid .mlm-production-count,
  .machine-live-monitor .mlm-grid .mlm-last-hour,
  .machine-live-monitor .mlm-grid .mlm-machine-status,
  .machine-live-monitor .mlm-grid .mlm-time-stats,
  .machine-live-monitor .mlm-grid .mlm-top-stops,
  .machine-live-monitor .mlm-grid .mlm-oee,
  .machine-live-monitor .mlm-grid .mlm-speed-nostop,
  .machine-live-monitor .mlm-grid .mlm-speed-total {
    grid-column: 1;
    grid-row: auto;
  }
}

.mlm-breaks-modal-body .mlm-breaks-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mlm-breaks-modal-body .mlm-break-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 32px;
  padding: 10px 12px;
  background: var(--m-surface-subtle, #f8fafc);
  border: 1px solid var(--m-border, #eaecf0);
  border-radius: 8px;
  font-size: 13px;
}
.mlm-breaks-modal-body .mlm-break-name {
  font-weight: 600;
  color: var(--m-text, #1a2236);
  min-width: 0;
  padding-right: 8px;
}
.mlm-breaks-modal-body .mlm-break-time {
  font-weight: 700;
  color: #c2410c;
  letter-spacing: 0.5px;
  white-space: nowrap;
  text-align: right;
}
.mlm-breaks-modal-body .mlm-breaks-empty {
  font-size: 13px;
  color: var(--m-text-light, #aab0bc);
  text-align: center;
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/MachineMonitor/MachineMonitor.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8CAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADN;AAGM;EACE,mBAAA;EACA,cAAA;AADR;AAGM;EACE,mBAAA;EACA,cAAA;AADR;AAIM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAFR;AAIM;EACE,mBAAA;AAFR;AAIM;EACE,0DAAA;EACA,mCAAA;AAFR;AAKM;EACE,mBAAA;AAHR;AAOI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AALN;AAQI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANN;AAQM;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;AANR;AAUI;EACE,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AARN;AAUM;EACE,qBAAA;EACA,6CAAA;AARR;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAYM;EACE,YAAA;EACA,mBAAA;AAVR;AAaM;EACE,kCAAA;AAXR;AAgBE;EACE;IACE,uBAAA;EAdJ;EAgBE;IACE,yBAAA;EAdJ;AACF;AAkBE;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,SAAA;AAhBJ;AAmBI;EACE,cAAA;EACA,WAAA;AAjBN;AAmBI;EACE,cAAA;EACA,WAAA;AAjBN;AAmBI;EACE,cAAA;EACA,WAAA;AAjBN;AAmBI;EACE,cAAA;EACA,WAAA;AAjBN;AAqBI;EACE,cAAA;EACA,WAAA;EACA,aAAA;AAnBN;AAqBI;EACE,cAAA;EACA,WAAA;EACA,aAAA;AAnBN;AAqBI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAnBN;AAuBI;EACE,gBAAA;EACA,WAAA;AArBN;AAuBI;EACE,cAAA;EACA,WAAA;AArBN;AAuBI;EACE,cAAA;EACA,WAAA;AArBN;AA0BE;EACE,gDAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,0CAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,gBAAA;AAzBN;AA4BI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AA1BN;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AA5BJ;AA8BI;EACE,gBAAA;AA5BN;AAgCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kFACE;AA/BN;AAmCI;EACE,cAAA;EACA,qCAAA;EACA,mBAAA;AAjCN;AAoCI;EACE,aAAA;EACA,mBAAA;AAlCN;AAsCE;EACE,oBAAA;EACA,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,cAAA;AApCJ;AAuCE;EACE,YAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yDACE;AAtCN;AAyCI;EACE,4CAAA;EACA,6BAAA;AAvCN;AA0CI;EACE,gDAAA;EACA,cAAA;EACA,mDAAA;AAxCN;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AA1CJ;AA6CE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,6DACE;AA5CN;AAgDI;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AA9CN;AAiDI;EACE,mBAAA;EACA,qBAAA;AA/CN;AAkDI;EACE,mBAAA;EACA,qBAAA;AAhDN;AAmDI;EACE,mBAAA;EACA,qBAAA;AAjDN;AAsDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,iDAAA;AApDJ;AAsDI;EACE,mBAAA;AApDN;AAwDE;EACE,eAAA;EACA,mCAAA;EACA,gBAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAvDJ;AAyDI;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;AAvDN;AA2DE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AAzDJ;AA4DE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,aAAA;EACA,sCACE;AA3DN;AA8DI;EACE,cAAA;EACA,UAAA;AA5DN;AAgEE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AA9DJ;AAiEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/DJ;AAkEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhEJ;AAmEE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAlEJ;AAoEI;EACE,mBAAA;EACA,cAAA;AAlEN;AAoEI;EACE,mBAAA;EACA,cAAA;AAlEN;AAqEI;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AAnEN;AAqEM;EACE,wBAAA;AAnER;AAyEE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAvEJ;AA0EE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,oBAAA;EACA,iBAAA;AAxEJ;AA2EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,0CAAA;AAzEJ;AA2EI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAzEN;AA4EI;EAEE,mBAAA;EACA,cAAA;EACA,qBAAA;AA3EN;AA8EI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA5EN;AA+EI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA7EN;AAgFI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA9EN;AAiFI;EAEE,4CAAA;EACA,mCAAA;EACA,sCAAA;AAhFN;AAoFE;EACE,eAAA;EACA,mCAAA;EACA,kBAAA;AAlFJ;AAqFE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;AAnFJ;AAsFE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AApFJ;AAuFE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,8CACE;AAtFN;AAyFI;EACE,mBAAA;EACA,qBAAA;AAvFN;AA2FE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAzFJ;AA4FE;EACE,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;AA1FJ;AA8FE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA5FJ;AA+FE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA7FJ;AAgGE;EACE,kBAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AA/FJ;AAiGI;EACE,gBAAA;AA/FN;AAmGE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,MAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,iCAAA;EACA,qBAAA;EACA,wCAAA;AAjGJ;AAmGI;EACE,qDAAA;AAjGN;AAoGI;EACE,WAAA;AAlGN;AAqGI;EACE,uBAAA;AAnGN;AAsGI;EACE,uBAAA;EACA,kBAAA;AApGN;AAuGI;EACE,oCAAA;AArGN;AAyGE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;AAvGJ;AAyGI;EACE,eAAA;AAvGN;AA0GI;EACE,gDAAA;AAxGN;AA4GM;EACE,cAAA;AA1GR;AA6GM;EACE,cAAA;EACA,gBAAA;AA3GR;AAgHE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AA9GJ;AAiHE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA/GJ;AAkHE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;AAhHJ;AAmHE;EACE,YAAA;AAjHJ;AAmHI;EACE,kBAAA;AAjHN;AAoHI;EACE,eAAA;EACA,gBAAA;AAlHN;AAsHE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AApHJ;AAsHI;EACE,mCAAA;EACA,eAAA;AApHN;AAuHI;EACE,cAAA;AArHN;AAyHE;EACE,eAAA;EACA,mCAAA;EACA,kBAAA;AAvHJ;AA0HE;EACE,WAAA;EACA,oCAAA;EACA,cAAA;AAxHJ;AA4HE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA1HJ;AA6HE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA3HJ;AA8HE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA5HJ;AA+HE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AA7HJ;AAgIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AA9HJ;AAiIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA/HJ;AAmIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAjIJ;AAmII;EACE,gBAAA;AAjIN;AAqIE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AAnIJ;AAsIE;EACE,eAAA;EACA,mCAAA;EACA,eAAA;AApIJ;AA4IE;EACE,gBAAA;AA1IJ;AA4II;EACE,cAAA;AA1IN;AA8IE;EACE,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;AA5IJ;AA+IE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;AA7IJ;AAgJE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AA9IJ;AAgJI;EACE,gBAAA;EACA,iBAAA;EACA,YAnCe;EAoCf,sBAAA;EACA,4CAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iDAAA;EACA,gBAAA;EACA,uBAAA;AA9IN;AAiJI;EACE,iBAAA;EACA,YAlDc;EAmDd,sBAAA;EACA,6BAAA;EACA,iDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/IN;AAkJI;;EAEE,UAAA;EACA,kBAAA;AAhJN;AAmJI;;;;;EAKE,SAAA;EACA,mBAAA;AAjJN;AAoJI;;EAEE,iBAAA;EACA,kBAAA;EACA,iBAAA;AAlJN;AAqJI;EACE,mBAAA;AAnJN;AAsJI;EACE,4CAAA;AApJN;AAuJI;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;AArJN;AAuJM;EACE,WAAA;EACA,YAAA;AArJR;AA0JE;EACE,cAAA;EACA,gBAAA;AAxJJ;AA4JE;EACE,aAAA;EACA,sBAAA;AA1JJ;AA6JE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;AA3JJ;AA8JE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AA5JJ;AA+JE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA7JJ;AAgKE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;AA9JJ;AAiKE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA/JJ;AAkKE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;AAhKJ;AAoKE;;EAEE,aAAA;EACA,sBAAA;EACA,8BAAA;AAlKJ;AAsKE;EACE;IACE,qCAAA;EApKJ;EAsKI;IACE,cAAA;IACA,WAAA;EApKN;EAsKI;IACE,cAAA;IACA,WAAA;EApKN;EAsKI;IACE,cAAA;IACA,WAAA;EApKN;EAsKI;IACE,cAAA;IACA,WAAA;EApKN;EAuKI;IACE,cAAA;IACA,WAAA;EArKN;EAuKI;IACE,cAAA;IACA,WAAA;EArKN;EAuKI;IACE,gBAAA;IACA,WAAA;EArKN;EAwKI;IACE,gBAAA;IACA,WAAA;EAtKN;EAwKI;IACE,cAAA;IACA,WAAA;EAtKN;EAwKI;IACE,cAAA;IACA,WAAA;EAtKN;AACF;AA0KE;EAhiCF;IAiiCI,aAAA;EAvKF;EAyKE;IACE,0BAAA;EAvKJ;EAyKI;;;;;;;;;;IAUE,cAAA;IACA,cAAA;EAvKN;AACF;;AA8KE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3KJ;AA8KE;EACE,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AA5KJ;AA+KE;EACE,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AA7KJ;AAgLE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AA9KJ;AAiLE;EACE,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;AA/KJ","sourcesContent":[".machine-live-monitor {\n  padding: 20px;\n  background: var(--m-background-color, #f4f6f9);\n  min-height: 100vh;\n\n  .mlm-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n\n    .mlm-header-left {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n    }\n\n    .mlm-title {\n      font-size: 20px;\n      font-weight: 700;\n      color: var(--m-text, #1a2236);\n      margin: 0;\n    }\n\n    .mlm-ws-status {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 12px;\n      font-weight: 500;\n      padding: 4px 10px;\n      border-radius: 20px;\n\n      &.online {\n        background: #e6f9f6;\n        color: #00a896;\n      }\n      &.offline {\n        background: #fdecea;\n        color: #d32f2f;\n      }\n\n      &::before {\n        content: \"\";\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n      }\n      &.online::before {\n        background: #00c9b7;\n      }\n      &.history {\n        background: var(--m-subtle-card-background-color, #f4f6fa);\n        color: var(--m-text-muted, #6a768b);\n      }\n\n      &.history::before {\n        background: #94a3b8;\n      }\n    }\n\n    .mlm-header-right {\n      display: flex;\n      align-items: flex-end;\n      gap: 12px;\n      flex-wrap: wrap;\n    }\n\n    .mlm-selector-wrap {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      label {\n        font-size: 11px;\n        font-weight: 600;\n        color: var(--m-text-light, #7a8499);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n    }\n\n    .mlm-select {\n      padding: 8px 14px;\n      border: 1px solid var(--m-border, #dde2ee);\n      border-radius: 8px;\n      background: var(--m-card-background-color, #fff);\n      font-size: 13px;\n      color: var(--m-text, #1a2236);\n      outline: none;\n      min-width: 180px;\n      cursor: pointer;\n\n      &:focus {\n        border-color: #00c9b7;\n        box-shadow: 0 0 0 3px rgba(0, 201, 183, 0.15);\n      }\n    }\n\n    .mlm-refresh-btn {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      padding: 8px 16px;\n      background: #00c9b7;\n      color: #fff;\n      border: none;\n      border-radius: 8px;\n      font-size: 13px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: background 0.2s;\n      height: 36px;\n\n      &:hover {\n        background: #00a896;\n      }\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n\n      .spin {\n        animation: spin 1s linear infinite;\n      }\n    }\n  }\n\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  // ── Grid layout ──────────────────────────────────\n  .mlm-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: auto auto auto;\n    gap: 16px;\n\n    // Row 1\n    .mlm-machine-info {\n      grid-column: 1;\n      grid-row: 1;\n    }\n    .mlm-shift-info {\n      grid-column: 2;\n      grid-row: 1;\n    }\n    .mlm-production-count {\n      grid-column: 3;\n      grid-row: 1;\n    }\n    .mlm-last-hour {\n      grid-column: 4;\n      grid-row: 1;\n    }\n\n    // Row 2\n    .mlm-machine-status {\n      grid-column: 1;\n      grid-row: 2;\n      min-height: 0;\n    }\n    .mlm-time-stats {\n      grid-column: 2;\n      grid-row: 2;\n      min-height: 0;\n    }\n    .mlm-top-stops {\n      grid-column: 3 / 5;\n      grid-row: 2;\n      min-height: 0;\n    }\n\n    // Row 3\n    .mlm-oee {\n      grid-column: 1 / 3;\n      grid-row: 3;\n    }\n    .mlm-speed-nostop {\n      grid-column: 3;\n      grid-row: 3;\n    }\n    .mlm-speed-total {\n      grid-column: 4;\n      grid-row: 3;\n    }\n  }\n\n  // ── Card base ──────────────────────────────────\n  .mlm-card {\n    background: var(--m-card-background-color, #fff);\n    border-radius: 12px;\n    padding: 18px 20px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);\n    border: 1px solid var(--m-border, #eaecf0);\n  }\n\n  .mlm-card-title {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--m-text-light, #7a8499);\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    margin-bottom: 14px;\n\n    &--inline {\n      margin-bottom: 0;\n    }\n\n    small {\n      font-size: 10px;\n      font-weight: 500;\n      text-transform: none;\n      letter-spacing: 0;\n      margin-left: 4px;\n    }\n  }\n\n  .mlm-card-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 14px;\n\n    .mlm-card-title--inline {\n      margin-bottom: 0;\n    }\n  }\n\n  .mlm-card-detail-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n    padding: 5px 8px;\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: 6px;\n    background: var(--m-card-background-color, #fff);\n    color: var(--m-text-light, #7a8499);\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      color 0.15s ease,\n      border-color 0.15s ease,\n      background-color 0.15s ease;\n\n    &:hover:not(:disabled) {\n      color: #00a896;\n      border-color: rgba(0, 201, 183, 0.45);\n      background: #e6f9f6;\n    }\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n  }\n\n  .mlm-stops-sort-toggle {\n    display: inline-flex;\n    align-items: stretch;\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: 6px;\n    overflow: hidden;\n    background: var(--m-background-color, #f6f7fb);\n    flex-shrink: 0;\n  }\n\n  .mlm-stops-sort-btn {\n    border: none;\n    background: transparent;\n    color: var(--m-text-light, #7a8499);\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 7px 10px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition:\n      background-color 0.15s ease,\n      color 0.15s ease;\n\n    &:hover {\n      background: var(--m-surface-subtle, #f8fafc);\n      color: var(--m-text, #1a2236);\n    }\n\n    &.active {\n      background: var(--m-card-background-color, #fff);\n      color: #00a896;\n      box-shadow: inset 0 0 0 1px rgba(0, 168, 150, 0.15);\n    }\n  }\n\n  .mlm-label-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .mlm-entry-add-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    background: #e6f9f6;\n    border: 1px solid rgba(0, 201, 183, 0.35);\n    border-radius: 50%;\n    color: #00a896;\n    cursor: pointer;\n    transition:\n      background 0.15s,\n      color 0.15s,\n      border-color 0.15s;\n\n    &:hover {\n      background: #00c9b7;\n      border-color: #00c9b7;\n      color: #fff;\n    }\n\n    &--scrap:hover {\n      background: #dc2626;\n      border-color: #dc2626;\n    }\n\n    &--production:hover {\n      background: #00b4f3;\n      border-color: #00b4f3;\n    }\n\n    &--stop:hover {\n      background: #ea580c;\n      border-color: #ea580c;\n    }\n  }\n\n  // ── Machine info card ──────────────────────────\n  .mlm-info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 0;\n    border-bottom: 1px solid var(--m-border, #f0f2f5);\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .mlm-info-label {\n    font-size: 12px;\n    color: var(--m-text-light, #7a8499);\n    font-weight: 500;\n  }\n\n  .mlm-info-value {\n    font-size: 13px;\n    color: var(--m-text, #1a2236);\n    font-weight: 600;\n    text-align: right;\n    max-width: 65%;\n    word-break: break-all;\n\n    &--part {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 6px;\n      word-break: normal;\n    }\n  }\n\n  .mlm-part-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .mlm-part-edit-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    padding: 2px;\n    background: transparent;\n    border: none;\n    border-radius: 4px;\n    color: var(--m-text-light, #7a8499);\n    cursor: pointer;\n    opacity: 0.85;\n    transition:\n      color 0.15s,\n      opacity 0.15s;\n\n    &:hover {\n      color: #00a896;\n      opacity: 1;\n    }\n  }\n\n  .mlm-cycle-edit-part {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--m-text, #1a2236);\n    margin-bottom: 14px;\n  }\n\n  .mlm-cycle-edit-form {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .mlm-cycle-edit-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .mlm-cycle-edit-error {\n    margin-top: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #c62828;\n  }\n\n  .mlm-status-badge {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 20px;\n\n    &.online {\n      background: #e6f9f6;\n      color: #00a896;\n    }\n    &.offline {\n      background: #fdecea;\n      color: #c62828;\n    }\n\n    &.is-clickable {\n      border: none;\n      cursor: pointer;\n      font-family: inherit;\n\n      &:hover {\n        filter: brightness(0.96);\n      }\n    }\n  }\n\n  // ── Shift info card ──────────────────────────\n  .mlm-shift-name {\n    font-size: 32px;\n    font-weight: 800;\n    color: var(--m-text, #1a2236);\n    line-height: 1;\n    margin-bottom: 4px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .mlm-shift-sub {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--m-text-light, #7a8499);\n    text-transform: none;\n    letter-spacing: 0;\n  }\n\n  .mlm-workstate-badge {\n    font-size: 11px;\n    font-weight: 800;\n    padding: 4px 10px;\n    border-radius: 999px;\n    letter-spacing: 0.4px;\n    text-transform: uppercase;\n    line-height: 1;\n    border: 1px solid var(--m-border, #eaecf0);\n\n    &.break {\n      background: #fff7ed;\n      color: #c2410c;\n      border-color: #fed7aa;\n    }\n\n    &.tolerance,\n    &.tolerance_late {\n      background: #eff6ff;\n      color: #1d4ed8;\n      border-color: #bfdbfe;\n    }\n\n    &.tolerance_start {\n      background: #f0fdf4;\n      color: #15803d;\n      border-color: #bbf7d0;\n    }\n\n    &.tolerance_early {\n      background: #fffbeb;\n      color: #b45309;\n      border-color: #fde68a;\n    }\n\n    &.overtime {\n      background: #faf5ff;\n      color: #7e22ce;\n      border-color: #e9d5ff;\n    }\n\n    &.outside,\n    &.no_shift {\n      background: var(--m-surface-subtle, #f1f5f9);\n      color: var(--m-text-light, #475569);\n      border-color: var(--m-border, #e2e8f0);\n    }\n  }\n\n  .mlm-shift-time-label {\n    font-size: 11px;\n    color: var(--m-text-light, #7a8499);\n    margin-bottom: 6px;\n  }\n\n  .mlm-shift-time-row {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .mlm-shift-time {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--m-text, #1a2236);\n    letter-spacing: 1px;\n  }\n\n  .mlm-breaks-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n    padding: 4px 7px;\n    background: #fff7ed;\n    color: #c2410c;\n    border: 1px solid #fed7aa;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      background 0.2s,\n      border-color 0.2s;\n\n    &:hover {\n      background: #ffedd5;\n      border-color: #fdba74;\n    }\n  }\n\n  .mlm-breaks-count {\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  .mlm-no-shift {\n    font-size: 13px;\n    color: var(--m-text-light, #aab0bc);\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  // ── Production count card ──────────────────────\n  .mlm-production-count {\n    overflow: hidden;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mlm-production-section-label {\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--m-text-light, #7a8499);\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    margin-bottom: 8px;\n  }\n\n  .mlm-production-produced {\n    margin-bottom: 2px;\n  }\n\n  .mlm-production-produced-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 8px;\n\n    .mlm-production-section-label {\n      margin-bottom: 0;\n    }\n  }\n\n  .mlm-production-parts {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    width: 100%;\n    max-width: 100%;\n    padding: 0px;\n    scroll-snap-type: x proximity;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: transparent transparent;\n\n    &:hover {\n      scrollbar-color: var(--m-border, #d0d5dd) transparent;\n    }\n\n    &::-webkit-scrollbar {\n      height: 3px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n      border-radius: 3px;\n    }\n\n    &:hover::-webkit-scrollbar-thumb {\n      background: var(--m-border, #d0d5dd);\n    }\n  }\n\n  .mlm-production-part-item {\n    flex: 0 0 auto;\n    min-width: 72px;\n    max-width: 96px;\n    padding: 0 16px;\n    scroll-snap-align: start;\n    text-align: center;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    &:not(:last-child) {\n      border-right: 1px solid var(--m-border, #dde2ee);\n    }\n\n    &.is-active {\n      .mlm-production-part-qty {\n        color: #00a896;\n      }\n\n      .mlm-production-part-name {\n        color: #008f80;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .mlm-production-part-qty {\n    font-size: 32px;\n    font-weight: 800;\n    color: var(--m-text, #1a2236);\n    line-height: 1;\n    margin-bottom: 6px;\n  }\n\n  .mlm-production-part-name {\n    font-size: 10px;\n    font-weight: 500;\n    color: var(--m-text-light, #7a8499);\n    line-height: 1.25;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .mlm-production-scrap {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .mlm-production-scrap-main {\n    min-width: 0;\n\n    .mlm-production-section-label {\n      margin-bottom: 4px;\n    }\n\n    .mlm-scrap-number {\n      font-size: 28px;\n      margin-bottom: 0;\n    }\n  }\n\n  .mlm-big-number {\n    font-size: 40px;\n    font-weight: 800;\n    color: var(--m-text, #1a2236);\n    line-height: 1;\n    margin-bottom: 4px;\n\n    &.secondary {\n      color: var(--m-text-light, #7a8499);\n      font-size: 28px;\n    }\n\n    &.mlm-scrap-number {\n      color: #dc2626;\n    }\n  }\n\n  .mlm-big-number-label {\n    font-size: 11px;\n    color: var(--m-text-light, #7a8499);\n    margin-bottom: 8px;\n  }\n\n  .mlm-divider {\n    height: 1px;\n    background: var(--m-border, #eaecf0);\n    margin: 10px 0;\n  }\n\n  // ── Machine status (donut) card ──────────────────\n  .mlm-machine-status {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .mlm-donut-container {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 8px 0;\n  }\n\n  .donut-wrap {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .donut-label {\n    position: absolute;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--m-text, #1a2236);\n    text-align: center;\n    pointer-events: none;\n    letter-spacing: 1px;\n  }\n\n  .mlm-donut-legend {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    color: var(--m-text-light, #7a8499);\n    font-weight: 600;\n    margin-top: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .mlm-legend-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n\n  // ── Time stats card ──────────────────────────\n  .mlm-time-row {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 14px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .mlm-time-value {\n    font-size: 24px;\n    font-weight: 800;\n    color: var(--m-text, #1a2236);\n    letter-spacing: 1px;\n    line-height: 1.2;\n  }\n\n  .mlm-time-label {\n    font-size: 11px;\n    color: var(--m-text-light, #7a8499);\n    margin-top: 2px;\n  }\n\n  // ── Top stops card ──────────────────────────\n  $mlm-stops-row-h: 33px;\n  $mlm-stops-head-h: 34px;\n  $mlm-stops-visible-rows: 5;\n\n  .mlm-top-stops {\n    overflow: hidden;\n\n    .mlm-card-title-row {\n      flex-shrink: 0;\n    }\n  }\n\n  .mlm-empty-stops {\n    font-size: 13px;\n    color: var(--m-text-light, #aab0bc);\n    text-align: center;\n    margin-top: 24px;\n  }\n\n  .mlm-stops-table-wrap {\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: $mlm-stops-head-h + ($mlm-stops-row-h * $mlm-stops-visible-rows);\n    margin: 0 -20px -4px;\n    width: calc(100% + 40px);\n  }\n\n  .mlm-stops-table {\n    width: 100%;\n    table-layout: auto;\n    border-collapse: collapse;\n    font-size: 12px;\n\n    th {\n      text-align: left;\n      padding: 8px 10px;\n      height: $mlm-stops-head-h;\n      box-sizing: border-box;\n      background: var(--m-surface-subtle, #f8fafc);\n      color: var(--m-text-light, #7a8499);\n      font-weight: 700;\n      font-size: 11px;\n      text-transform: uppercase;\n      border-bottom: 1px solid var(--m-border, #eaecf0);\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    td {\n      padding: 8px 10px;\n      height: $mlm-stops-row-h;\n      box-sizing: border-box;\n      color: var(--m-text, #1a2236);\n      border-bottom: 1px solid var(--m-border, #f4f6f9);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    th:nth-child(1),\n    td:nth-child(1) {\n      width: 14%;\n      padding-left: 20px;\n    }\n\n    th:nth-child(4),\n    td:nth-child(4),\n    th:nth-child(5),\n    td:nth-child(5),\n    .mlm-stops-action-col {\n      width: 1%;\n      white-space: nowrap;\n    }\n\n    th:nth-child(5),\n    td:nth-child(5) {\n      text-align: right;\n      padding-right: 4px;\n      padding-left: 4px;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:hover td {\n      background: var(--m-surface-subtle, #f8fafc);\n    }\n\n    .mlm-stops-action-col {\n      text-align: center;\n      padding: 8px 16px 8px 2px;\n      overflow: visible;\n\n      .mlm-entry-add-btn {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  .mlm-ongoing {\n    color: #f59e0b;\n    font-weight: 600;\n  }\n\n  // ── OEE gauges card ──────────────────────────\n  .mlm-oee {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mlm-gauges-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    flex: 1;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  .gauge-circle-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .gauge-circle-svg-wrap {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .gauge-circle-value {\n    position: absolute;\n    font-size: 16px;\n    font-weight: 800;\n    color: var(--m-text, #1a2236);\n    text-align: center;\n    line-height: 1;\n  }\n\n  .gauge-unit {\n    font-size: 10px;\n    font-weight: 500;\n    display: block;\n    text-align: center;\n    margin-top: 1px;\n  }\n\n  .gauge-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--m-text-light, #7a8499);\n    text-align: center;\n    white-space: nowrap;\n  }\n\n  // ── Speed cards ──────────────────────────────\n  .mlm-speed-nostop,\n  .mlm-speed-total {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  // ── Responsive ───────────────────────────────\n  @media (max-width: 1200px) {\n    .mlm-grid {\n      grid-template-columns: repeat(2, 1fr);\n\n      .mlm-machine-info {\n        grid-column: 1;\n        grid-row: 1;\n      }\n      .mlm-shift-info {\n        grid-column: 2;\n        grid-row: 1;\n      }\n      .mlm-production-count {\n        grid-column: 1;\n        grid-row: 2;\n      }\n      .mlm-last-hour {\n        grid-column: 2;\n        grid-row: 2;\n      }\n\n      .mlm-machine-status {\n        grid-column: 1;\n        grid-row: 3;\n      }\n      .mlm-time-stats {\n        grid-column: 2;\n        grid-row: 3;\n      }\n      .mlm-top-stops {\n        grid-column: 1 / 3;\n        grid-row: 4;\n      }\n\n      .mlm-oee {\n        grid-column: 1 / 3;\n        grid-row: 5;\n      }\n      .mlm-speed-nostop {\n        grid-column: 1;\n        grid-row: 6;\n      }\n      .mlm-speed-total {\n        grid-column: 2;\n        grid-row: 6;\n      }\n    }\n  }\n\n  @media (max-width: 640px) {\n    padding: 12px;\n\n    .mlm-grid {\n      grid-template-columns: 1fr;\n\n      .mlm-machine-info,\n      .mlm-shift-info,\n      .mlm-production-count,\n      .mlm-last-hour,\n      .mlm-machine-status,\n      .mlm-time-stats,\n      .mlm-top-stops,\n      .mlm-oee,\n      .mlm-speed-nostop,\n      .mlm-speed-total {\n        grid-column: 1;\n        grid-row: auto;\n      }\n    }\n  }\n}\n\n// Modal is portaled to document.body — cannot nest under .machine-live-monitor\n.mlm-breaks-modal-body {\n  .mlm-breaks-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .mlm-break-row {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    column-gap: 32px;\n    padding: 10px 12px;\n    background: var(--m-surface-subtle, #f8fafc);\n    border: 1px solid var(--m-border, #eaecf0);\n    border-radius: 8px;\n    font-size: 13px;\n  }\n\n  .mlm-break-name {\n    font-weight: 600;\n    color: var(--m-text, #1a2236);\n    min-width: 0;\n    padding-right: 8px;\n  }\n\n  .mlm-break-time {\n    font-weight: 700;\n    color: #c2410c;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n    text-align: right;\n  }\n\n  .mlm-breaks-empty {\n    font-size: 13px;\n    color: var(--m-text-light, #aab0bc);\n    text-align: center;\n    padding: 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
